import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import SmartBanner from 'react-smartbanner'

// there was no other working way than moving 'react-smartbanner/dist/main.css' to /static and
// importing it directly onto the mounted html document

import PropTypes from 'prop-types'

@injectIntl
class MobileAppLink extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired
  }

  render() {
    const title = this.props.intl.formatMessage({
      id: 'label.orb_participant_app',
      defaultMessage: 'ORB Participant App'
    })
    const button = this.props.intl.formatMessage({
      id: 'label.orb_participant_app_button',
      defaultMessage: 'Get it'
    })

    return (
      <SmartBanner title={title} button={button} />
    )
  }
}

export default MobileAppLink
